import { BulletPointsConfigModel, BulletpointsProductModel, ExtraLinksConfigModel, ExtraLinksConfigWrapper, ExtraLinksProductModel, InfoTextConfigModel, InfotextProductModel, LogoConfigModel, LogoProductModel, SearchWordsConfigModel, WebshopProductModel } from "models/WebShop";

export const getPayloadString = (product: WebshopProductModel): string => {
  if (isLogoProduct(product)) {
    return JSON.stringify({ img: product.img });
  } else if (isBulletpointsProduct(product)) {
    return JSON.stringify({ bulletpoints: product.bulletpoints });
  } else if (isInfotextProduct(product)) {
    return JSON.stringify({ infotext: product.infotext });
  } else if (isExtraLinksProduct(product)) {
    return JSON.stringify({ extraLinks: product.extraLinks });
  } else {
    return "";
  }
};

export function isLogoProduct(product: WebshopProductModel): product is LogoProductModel {
  return (product as LogoProductModel).img !== undefined;
}

export function isBulletpointsProduct(product: WebshopProductModel): product is BulletpointsProductModel {
  return (product as BulletpointsProductModel).bulletpoints !== undefined;
}

export function isInfotextProduct(product: WebshopProductModel): product is InfotextProductModel {
  return (product as InfotextProductModel).infotext !== undefined;
}

export function isExtraLinksProduct(product: WebshopProductModel): product is ExtraLinksProductModel {
  return (product as ExtraLinksProductModel).extraLinks !== undefined;
}







export type EmptyPredicate<T> = (value: T | null | undefined) => boolean;

const isNil = (v: unknown): v is null | undefined => v === null || v === undefined;

export const isLogoConfigEmpty: EmptyPredicate<LogoConfigModel> = (v) =>
  !isNil(v) && v.publicUrlTransform === "https://res.cloudinary.com/dm1881/image/upload/t_www-logo/.png";

export const isInfoTextConfigEmpty: EmptyPredicate<InfoTextConfigModel> = (v) => 
  !isNil(v) && (v.text === null || v.text.trim() === "");

export const isBulletPointsConfigEmpty: EmptyPredicate<BulletPointsConfigModel> = (v) =>
  !isNil(v) && v.bulletPoints.every(x => x === "");

export const isExtraLinkConfigEmpty: EmptyPredicate<ExtraLinksConfigWrapper> = (v) =>
  !isNil(v) && v.extraLinks.every(x => x.url === null);

export const isSearchWordsConfigEmpty: EmptyPredicate<SearchWordsConfigModel> = (v) =>
  !isNil(v) && v.searchWords === null